import { apiDelete } from "../client";
import { useMutation } from "@tanstack/react-query";

export const deleteRetake = async (originalExamProgressId: string) => {
  const response = await apiDelete<null>(
    `/exam_progress/${originalExamProgressId}/retake`
  );
  return response.data;
};

export const useMutationDeleteRetake = () => {
  return useMutation({
    mutationFn: deleteRetake,
  });
}; 